import { fetchApi } from "../utils/fetchApi";

export function fetchSumcharge({ filter = {}, options = {} }) {  
  return fetchApi({ url: 'sumcharge', filter, options });
}

